import React, { useEffect } from 'react';
import Footer from '../components/Footer';
const processStages = [
  {
    title: "컨셉디자인",
    imageUrl: "../assets/images/process_01.png",
    description: "현장 방문과 창의적인 상담으로 시작하여 당신의 비전, 스타일, 기능적 요구 사항을 정의합니다. 우리는 또한 새로운 기회와 잠재적 한계를 발견할 것입니다. 이를 바탕으로, 우리는 당신의 브리프를 반영하는 초기 시각적 컨셉을 제공하기 위해 일련의 손으로 그린 디자인 스케치를 만듭니다. 협업과 수정을 통해, 우리는 당신의 목표, 일정 및 예산에 맞게 컨셉을 구체화합니다."
  },
  {
    title: "디자인 개발",
    imageUrl: "../assets/images/process_02.png",
    description: "여기서 우리는 초기 스케치를 가져와 건물 재료 선택, 내외부 인터페이스, 평면도, 레이아웃, 지시적 가구 디자인 및 공간 흐름을 포함한 모든 영광스러운 세부 사항을 채웁니다. 저희 팀은 집의 모양, 느낌, 레이아웃을 생생하게 보여주는 상세한 디지털 2D 도면과 3D 모델을 제작할 것입니다."
  },
  {
    title: "마감재협의 및 디자인",
    imageUrl: "../assets/images/process_02_1.png",
    description: "초기 디자인을 바탕으로 건축 재료, 색상, 마감재 등 구체적인 요소를 협의하고 선정합니다. 내외부 마감재, 가구, 조명, 설비 등 공간의 모든 디테일을 함께 논의하며, 2D 도면과 3D 모델을 통해 디자인을 현실화하고 고객의 비전에 완벽하게 부합하도록 조정합니다."
  },
  {
    title: "세부 도면화",
    imageUrl: "../assets/images/process_03.png",
    description: "선정된 디자인 컨셉을 기반으로 건축 및 인테리어의 모든 요소를 상세하게 도면화합니다. 구조, 설비, 전기, 조명, 마감재 등 시공에 필요한 모든 정보를 포함하는 정밀한 2D 및 3D 도면을 작성하여, 시공 과정에서의 오차를 최소화하고 완벽한 구현을 위한 지침을 제공합니다."
  },
  {
    title: "시공계획 및 공사",
    imageUrl: "../assets/images/process_04.png",
    description: "모든 디자인 세부 사항이 확정되고 건물 승인이 완료되면, 우리는 의도된 디자인을 현실로 만들기 위해 건축업자와 기술자들을 안내할 시공 계획, 도면 및 문서를 만드는 데 주의를 기울입니다. 우리는 모든 요소가 완전히 해결되고 상세하게 전달되도록 전체 팀과 협력하고 조정할 것입니다."
  }
];

const ProcessPage = () => {
  useEffect(() => {
    document.body.setAttribute('data-barba-namespace', 'process');
    return () => {
      document.body.removeAttribute('data-barba-namespace');
    };
  }, []);

  return (
    <main className="page_main">
      <section className="process_hero_wrap">
        <div className="process_hero_content">
          <div className="process_hero_top u-grid-custom">
            <div className="process_hero_eyebrow">
              <div data-wf--global-eyebrow--variant="base" className="g_eyebrow u-text-small">process</div>
            </div>
            <h1 aria-hidden={true} data-lines-split="" data-split-animation="" id="w-node-e2e731eb-795a-7384-0926-2571ab7ebe8f-e11fae5c" className="process_hero_heading u-text-h3">
              <span className="text-span-6">건축은 기술이 아닌 사람과 사람의 협업, 그리고 신뢰의 관계입니다.</span>
            </h1>
            <h1 className="process_hero_heading u-text-h3 u-sr-only">
              <span className="text-span-6">Great</span> architecture isn't just about talent and experience, but collaborations and relationships.
            </h1>
          </div>
          <div className="process_cover_wrap u-grid-tablet">
            <div data-image-transition-anim="" data-orientation="landscape" id="w-node-f4084757-f22d-23e4-8638-7687a703cdaa-e11fae5c" className="process_hero_cover">
              <div data-image-cover="" className="g_image_cover"></div>
              <img src="/assets/images/Image_fx (43).jpg" loading="eager" id="w-node-d6fe9086-39d8-0535-a86a-6338733d5f5e-e11fae5c" data-image="" alt="A person working on a laptop in a modern office." className="process_hero_image" />
            </div>
          </div>
        </div>
      </section>

      <section className="process_hero_details u-grid-custom">
        <div id="w-node-_3ead9780-c21b-c51c-8bf5-490a98125aba-e11fae5c" className="process_hero_eyebrow">
          <div data-wf--global-eyebrow--variant="base" className="g_eyebrow u-text-small"></div>
        </div>
        <div id="w-node-_9d865012-524f-deb1-d6d7-3323fe93f32f-e11fae5c" className="process_hero_main">
          <p aria-hidden={true} data-lines-split="" data-animate-scroll="" className="process_hero_paragraph u-text-large">
            저희는 건축을 기술과 경험을 넘어선, 함께 만들어가는 관계의 예술로 정의합니다.
          </p>
          <p className="process_hero_paragraph u-text-large u-sr-only">
            건축은 기술이 아닌 사람과 사람의 협업, 그리고 신뢰의 관계입니다.
          </p>
          <button data-wf--btn-contact--variant="base" data-link-hover="" data-contact-btn="" className="btn_default_wrap">
            <div className="btn_default_contain">
              <div data-link="" className="btn_default_text">상담신청</div>
            </div>
            <div className="g_circle is-light"></div>
          </button>
        </div>
        <div id="w-node-a8434e92-c1b1-5360-6656-ccbd6494695c-e11fae5c" className="process_hero_year">
          <div data-wf--global-eyebrow--variant="base" className="g_eyebrow u-text-small">©2025</div>
        </div>
      </section>

      <section data-start="top bottom" data-scroll-container="" data-target-translate="200" className="process_parallax_wrap">
        <div className="process_parallax_cover">
          <div className="hero_project_overlay"></div>
          <img src="/assets/images/Image_fx (74).jpg" className="process_parallax_image" alt="A modern building with a large glass facade." />
        </div>
        <div className="process_parallax_contain">
          <h2 className="process_parallax_heading u-text-display">성공적인 공간 완성을 위한 6단계 프로세스</h2>
          <div className="process_parallax_deco u-text-display">→</div>
        </div>
      </section>

      <section className="process_stages_wrap">
        <div className="process_stages_contain">
          <div className="process_stages_collection w-dyn-list">
            <div role="list" className="process_stages_list w-dyn-items">
              {processStages.map((stage, index) => (
                <div key={index} role="listitem" className="process_stages_item w-dyn-item">
                  <div className="process_stages_contain u-grid-landscape">
                    <div className="process_stages_overlay"></div>
                    <div data-process-item="" id="w-node-_8f43c4e5-6e95-b014-187e-cd215885b8f0-e11fae5c" className="process_stages_index u-text-display">
                      0<span data-process-value="" className="process_stages_value">{index + 1}</span>
                    </div>
                    <div id="w-node-_1b2d8a8e-aca0-9cdf-b8e3-4b994f19b5f7-e11fae5c" className="process_stages_content">
                      <h2 className="process_stages_heading u-text-h2">{stage.title}</h2>
                      <div data-image-reveal="" id="w-node-_17cf09c2-1d6c-3d49-5fe9-ef3a309a2c10-e11fae5c" className="process_stages_cover">
                        <div data-image-cover="" className="g_image_cover"></div>
                        <img src={stage.imageUrl} loading="lazy" data-image="" alt={stage.title} className="process_stages_image" />
                      </div>
                      <div className="process_stages_bottom">
                        <p id="w-node-_1b5efe00-4ff5-e26c-60be-825551157a39-e11fae5c" className="process_stages_paragraph u-text-main">
                          {stage.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default ProcessPage;
